import React, { useRef } from "react";
import "./Home.css";
// import Button from "@mui/material/Button";
// import Navbar from "./Components/Navbar/Navbar";
// import Homepage from "./Screens/Homepage/Homepage";
import image from "../../Images/image.png";
import image1 from "../../Images/image (1).png";
import image2 from "../../Images/image (2).png";
import image3 from "../../Images/image (3).png";
import { useState } from "react";
import { CgQuote } from "react-icons/cg";
import { BsSoundwave } from "react-icons/bs";
import { TbMessageCircleFilled } from "react-icons/tb";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import scrollTrigger from "gsap/ScrollTrigger";
import SwiperCard from "../../Components/Swiper/SwiperCard";
import cosmetic_eyeliner from "../../Images/cosmetic_eyeliner.jpg";
import cosmetic_brush from "../../Images/cosmetic_brush.jpg";
import cosmetic_lipstick from "../../Images/cosmetic_lipstick.jpg";
import cosmetic_hair from "../../Images/cosmetic_hair.jpg";
import ImmersiveBeauty from "../../Components/HomeComponents/Immersive Beauty/ImmersiveBeauty";
import { Outlet } from "react-router-dom";
import HomeHeroSection from "../../Components/HomeComponents/HomeHeroSection/HomeHeroSection";
import BeautyConsultation from "../../Components/HomeComponents/BeautyConsultation/BeautyConsultation";
import "../Home/beautyProduct.css";
import BlogSection from "../../Components/BlogSection/BlogSection";
import TopPicks from "../../Components/TopPicks/TopPicks";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(scrollTrigger);

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // const [scrollingHandle, setScrollingHandle] = useState(0);
  const yoyoSpan1 = useRef(null);
  const yoyoSpan2 = useRef(null);
  const yoyoSpan3 = useRef(null);

  const imagesArr = [
    { image: image },
    { image: image1 },
    { image: image2 },
    { image: image3 },
  ];

  useGSAP(() => {
    gsap.from(yoyoSpan1.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.from(yoyoSpan2.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.from(yoyoSpan3.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.fromTo(
      ".mutlipleFrames .mutlipleFramesContainer video, .mutlipleFrames .mutlipleFramesContainer .videoImage1, .mutlipleFrames .mutlipleFramesContainer .videoImage2, .mutlipleFrames .mutlipleFramesContainer .videoImage3, .mutlipleFrames .mutlipleFramesContainer .videoImage4",
      {
        scale: 0.2, // Start slightly bigger than 0.1 for a smoother effect
        // opacity: 0, // Start with opacity 0
      },
      {
        scale: 1,
        // opacity: 1,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".mutlipleFrames .mutlipleFramesContainer",
          scroller: "body",
          start: "5% 80%",
          end: "top 0%",
          // scrub: 1,
          markers: false,
        },
      }
    );
  });

  return (
    <>
      <Outlet />
      <HomeHeroSection />

      {/* <Collections></Collections> */}
      {/* <SkinToneDectector></SkinToneDectector> */}
      {/* <Header></Header> */}

      <div className="heading">
        <div>
          <span ref={yoyoSpan1}></span>
          <h1>Luxury makeup for a glam look</h1>
        </div>
        <p>
          Flawless finish with a touch of luxury and elegance, enhancing beauty
          with radiant glow.
        </p>
      </div>
      <SwiperCard></SwiperCard>

      <div className="heading2">
        <div>
          <span ref={yoyoSpan2}></span>
          <h1>Stay close and in touch</h1>
        </div>
        <p>
          Call and text with uninterrupted clarity using Ai Pin’s built-in
          personic speaker or Bluetooth audio.
        </p>
      </div>
      <div className="changeAbleImageContainer">
        <div className="changeAbleImage">
          <img src={imagesArr[activeIndex].image} alt="bgimage" />
        </div>
        <div className="contentContainer">
          <div className="buttonContainer">
            <div
              className="slider"
              style={{ left: `${activeIndex * 25}%` }}
            ></div>

            {["image 1", "image 2", "image 3", "image 4"].map(
              (label, index) => (
                <button
                  key={index}
                  className={activeIndex === index ? "active" : ""}
                  onClick={() => setActiveIndex(index)}
                >
                  {label}
                </button>
              )
            )}
          </div>
          <div className="data">
            <div className="left">
              <p>
                <CgQuote className="dataIcon1" />
                Ask Cami if we're meeting at our usual spot and tell her that
                we'll be heading over there soon.
              </p>
              <p>
                <BsSoundwave className="soundwave-icon dataIcon2" /> {""}
                Your message to Cami says "Hey Cami, are we meeting at our usual
                spot? We’ll be heading there..."
              </p>
            </div>
            <div className="right">
              <div className="messageBox">
                <TbMessageCircleFilled className="messageIcon" />
                <p>Unlimited data, calling & texting</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mutlipleFrames">
        <div className="mutlipleFramesContainer">
          <video loop muted autoPlay className="video1">
            <source src={video1} type="video/mp4" />
          </video>
          <video loop muted autoPlay className="video2">
            <source src={video2} type="video/mp4" />
          </video>

          <video loop muted autoPlay className="video3">
            <source src={video3} type="video/mp4" />
          </video>

          <video loop muted autoPlay className="video4">
            <source src={{ video4 }} type="video/mp4" />
          </video>
          <div className="videoImage1">
            <img src={videoImage2} alt="videoImage1" />
          </div>
          <div className="videoImage2">
            <img src={videoImage3} alt="videoImage2" />
          </div>
          <div className="videoImage3">
            <img src={videoImage1} alt="videoImage3" />
          </div>
          <div className="videoImage4">
            <img src={videoImage2} alt="videoImage1" />
          </div>
        </div>
      </div> */}

      <div className="heading2">
        <div>
          <span ref={yoyoSpan3}></span>
          <h1>Personalized Beauty Consultation</h1>
        </div>
        <p>with makeup artist and skin care specialist</p>
      </div>

      <BeautyConsultation />

      <div className="cosmeticProductsHeading">
        <div>
          <span ref={yoyoSpan3}></span>
          <h1>cosmetic products</h1>
        </div>
        <p>Call and text with uninterrupted clarity using Ai</p>
      </div>
      <div className="cosmeticProducts">
        <img
          src={cosmetic_eyeliner}
          className="cosmeticProduct1"
          alt="cosmetic_eyeliner"
        />
        <img
          src={cosmetic_lipstick}
          className="cosmeticProduct2"
          alt="cosmetic_lipstick"
        />
        <img
          src={cosmetic_brush}
          className="cosmeticProduct2"
          alt="cosmetic_brush"
        />
        <img
          src={cosmetic_hair}
          className="cosmeticProduct4"
          alt="cosmetic_hair"
        />
      </div>

      <ImmersiveBeauty />
      <TopPicks />
      <BlogSection />
    </>
  );
};

export default Home;
